import { render, staticRenderFns } from "./CurrentTasks.vue?vue&type=template&id=7df4d98a&scoped=true&"
import script from "./CurrentTasks.vue?vue&type=script&lang=js&"
export * from "./CurrentTasks.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTasks.vue?vue&type=style&index=0&id=7df4d98a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4d98a",
  null
  
)

export default component.exports